import TableTemplate from "../../TableTemplate/tableTemplate";
import { Header } from "../../../Interfaces/TableInterfaces";
import { useAppDispatch } from "../../../App/hooks";
import { useState } from "react";
import ManualTradeTableUI from "./TableUI";
import {
  IManualAddOrderFormValues,
  IManualTablesSearchParam,
  IManualTradeTableReport,
} from "../../../Interfaces/manualInterfaces";
import {
  getManualTradeAggregateExcelFile,
  getManualTradeExcelFile,
  getManualTradeTable,
} from "../../../Requests/manualRequests";
import { setManualOrderFormValues } from "../../../Features/Manual/manualSlice";
import { store } from "../../../App/store";
import ExpandableButton from "../../../Components/ExpandableButton";
import FileDownloader from "../../../Components/FileDownloader";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

interface TradeTableProps {
  searchParam: IManualTablesSearchParam;
}

const ManualTradeTable = ({ searchParam }: TradeTableProps) => {
  const dispatch = useAppDispatch();

  const onTableRowClick = (row: IManualTradeTableReport) => {
    dispatch(
      setManualOrderFormValues({
        ...store.getState().manual.addOrderFormValues,
        instrumentId: row?.instrument,
        instrumentType: row?.instrumentType,
      } as IManualAddOrderFormValues)
    );
  };

  return (
    <div className="flex flex-col gap-3 justify-start items-end w-full trade-table relative">
      <div className="mt-2 absolute -left-10 -top-12">
        <ExpandableButton
          toolButton
          title="دانلود فایل"
          btnVariant="outlined"
          children={[
            <FileDownloader getFile={() => getManualTradeExcelFile(searchParam)} label="Excel" variant="menu" />,
            <FileDownloader getFile={() => getManualTradeAggregateExcelFile(searchParam)} label="Excel تجمیعی" variant="menu" />,
          ]}
          text={<FileDownloadOutlinedIcon fontSize="small" />}
        />
      </div>
      <TableTemplate<IManualTablesSearchParam, IManualTradeTableReport>
        refreshTableTime={5000}
        getDataTable={(searchParam, offset, pageSize, sortingType) =>
          getManualTradeTable(searchParam, offset, pageSize, sortingType || "")
        }
        withSort
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <ManualTradeTableUI
            reports={reports}
            onAction={onAction}
            onTableRowClick={onTableRowClick}
            sortingType={sortingType}
            setSortingType={setSortingType}
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default ManualTradeTable;
